import styled from "styled-components";

export const DropdownStyled = styled.div`
  .dropdown-toggle::after {
    display: none;
  }
`;

export const DropdownItemStyled = styled.div`
    cursor: pointer;
    padding: 12px 16px;
    border-bottom: 1px solid var(--color-surface-secondary);
    &:hover {
        background-color: var(--color-main);
    }
    &.disabled {
        color: #adb5bd;
        pointer-events: none;
        background-color: transparent;
    }
`;
